import { useState, useEffect } from "react"
import Auth from "./pages/Auth"
import Chat from "./pages/Chat"
import "./App.css"

function App() {
  const [token, setToken] = useState(() => localStorage.getItem("jaureguichat_token"))
  const [userId, setUserId] = useState(() => localStorage.getItem("jaureguichat_userId"))
  const [nombre, setNombre] = useState(() => localStorage.getItem("jaureguichat_nombre") || "")

  useEffect(() => {
    if (token && !userId) {
      fetch("http://localhost:8000/auth/me", {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(r => r.ok ? r.json() : Promise.reject())
        .then(data => {
          setUserId(data.userId)
          setNombre(data.nombre || "")
          localStorage.setItem("jaureguichat_userId", data.userId)
          localStorage.setItem("jaureguichat_nombre", data.nombre || "")
        })
        .catch(() => handleLogout())
    }
  }, [token, userId])

  const handleLogin = (token, userId, nombre) => {
    localStorage.setItem("jaureguichat_token", token)
    localStorage.setItem("jaureguichat_userId", userId)
    localStorage.setItem("jaureguichat_nombre", nombre || "")
    setToken(token)
    setUserId(userId)
    setNombre(nombre || "")
  }

  const handleLogout = () => {
    localStorage.removeItem("jaureguichat_token")
    localStorage.removeItem("jaureguichat_userId")
    localStorage.removeItem("jaureguichat_nombre")
    setToken(null)
    setUserId(null)
    setNombre("")
  }

  if (!token || !userId) {
    return <Auth onLogin={handleLogin} />
  }

  return <Chat token={token} userId={userId} nombre={nombre} onLogout={handleLogout} />
}

export default App
